import React, { Fragment, useCallback, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const InsulinSettingContext = React.createContext({});

const initialMatch = (document.location.search || '').match(/[?&]showBolus=([^&]+)/);
const predefinedFocus = initialMatch ? initialMatch[1] : undefined;

export function InsulinSettingContextProvider({ children = <Fragment /> }) {

  const [bolusFocus, selectBolusFocus] = useState(predefinedFocus);
  const location = useLocation();
  const history = useHistory();

  const { pathname, search = '' } = location;

  const fixUrl = useCallback((newLocation) => {
    history.replace(newLocation);
  }, [history]);

  const selectBolusFocusAndFixUrl = (focus) => {
    const match = search.match(/[?&]showBolus=([^&]+)/);
    if (!focus) {
      let newSearch = match ? search.replace(match[0], '') : '';
      if (newSearch[0] === '&') {
        newSearch[0] = '?';
      }
      fixUrl({
        pathname,
        search: newSearch,
      });
    } else {
      if (match) {
        const newSearch = search.replace(match[0], match[0].replace(match[1], focus));
        fixUrl({
          pathname,
          search: newSearch,
        });
      } else {
        fixUrl({
          pathname,
          search: `${search}${search.length ? '&' : '?'}showBolus=${focus}`,
        });
      }
    }
    selectBolusFocus(focus);
  }

  const state = Object.freeze({
    bolusFocus,
    selectBolusFocus: selectBolusFocusAndFixUrl
  });

  return (
    <InsulinSettingContext.Provider value={state}>
      {children}
    </InsulinSettingContext.Provider>
  );
}

export default InsulinSettingContext;
